import * as React from 'react';
import { PulseLoader } from 'react-spinners';
import { ReactComponent as ExitIcon } from './../assets/icons/exit-icon.svg';

export interface MessageModalProps {
  isLoading?: boolean;
  closeModal: () => void;
}

const MessageModal: React.FC<MessageModalProps> = ({ children, isLoading, closeModal }) => {
  return (
    <div className="font-nunitoRegular flex justify-center items-center fixed top-0 left-0 h-screen w-screen bg-green-200 bg-[rgba(27,27,27,0.5)] z-[1000] px-6">
      <div className="relative bg-white min-w-[50%] max-w-screen-lg rounded py-9 px-10 min-h-[300px] max-h-[80vh] overflow-y-scroll">
        <ExitIcon className="cursor-pointer absolute top-[31px] right-[25px]  z-[100]" onClick={() => closeModal()} />
        {isLoading ? (
          <div className="absolute top-0 left-0 h-full w-full bg-[rgba(256,256,256,0.6)] z-[100] flex items-center justify-center">
            <PulseLoader size={15} />
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default MessageModal;
